module.exports = __webpack_public_path__ + "static/media/help-circle-light.828e5760.svg";